export default __webpack_public_path__ + "static/media/Boots of the Faceless Sphinx.eb7f8ea4.jpg";